import { queryOptions, useQuery } from '@tanstack/react-query';
import { useApi } from '../../api/api-context';
/**
 * Fetches the user's subscription details.
 *
 * @param {ReturnType<typeof useApi>} api - API instance for making requests.
 * @returns {Promise<Subscription>} - A promise resolving to the subscription data.
 */
const fetchSubscription = async (api) => {
    const response = await api.get('/subscription/user');
    return response.data;
};
/**
 * Exposed query options for fetching the user's subscription.
 *
 * @param {ReturnType<typeof useApi>} api - API instance.
 * @returns Query options for React Query.
 */
export const getSubscriptionQueryOptions = (api) => queryOptions({
    queryKey: ['subscription'],
    queryFn: () => fetchSubscription(api),
});
/**
 * React Query hook for fetching the user's subscription.
 *
 * @param {UseSubscriptionOptions} options - Optional configuration for the query.
 * @returns {object} React Query response object.
 */
export const useGetSubscriptionApi = ({ queryConfig } = {}) => {
    const api = useApi();
    return useQuery({
        ...getSubscriptionQueryOptions(api),
        ...queryConfig,
    });
};
